import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Chat as ChatIcon, ContactPage, Logout, Person } from "@mui/icons-material";
import { Badge, Card, IconButton, ListItemIcon, MenuItem, MenuList, Popover, Stack, Typography } from "@mui/material";
import useAppContext from "src/hooks/useAppContext";
import { WEB_API } from "src/config";

function Chat() {
  const [hasMessages, setHasMessages] = useState(false);

  const pointer = useRef(localStorage.getItem('lastMessagesFlagUpdate') || Date.now());

  const hasMessagesRef = useRef(Boolean(Number(localStorage.getItem('unreadFlag'))));

  const navigate = useNavigate();
  const { getIdToken, user } = useAppContext();

  const getUnreadFlag = async () => {
    try {
      if (hasMessagesRef.current) {
        setHasMessages(true);
        return;
      }

      let params = {};
      if (user?.email) {
        const token = await getIdToken();
        params = {
          url: `${WEB_API}/get_unread_flag/${pointer.current}`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      } else {
        params = {
          url: `${WEB_API}/get_unread_flag/${pointer.current}?user_id=${user.userId}`,
          method: 'GET'
        }
      }

      // setLoading(true);

      const resp = await axios.request({
        ...params,
        headers: {
          ...(params.headers || {}),
          'Access-Control-Allow-Origin': '*',
          Accept: '*/*'
        }
      });

      pointer.current = Date.now();
      localStorage.setItem('lastMessagesFlagUpdate', pointer.current);
      if (resp.data.unreadFlag) {
        hasMessagesRef.current = true;
        localStorage.setItem('unreadFlag', 1);
        setHasMessages(true);
      }

      return resp.data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  useEffect(() => {
    (async () => {
      const resp = await getUnreadFlag();

      if (resp?.cod && Number(resp.cod) !== 404) {
        const interval = setInterval(getUnreadFlag, 30000);
        return () => clearInterval(interval);
      }
    })()
    // eslint-disable-next-line
  }, []);

  return (
    <Badge
      color="error"
      invisible={!hasMessages}
      variant="dot"
      overlap="circular"
      sx={{
        "& .MuiBadge-dot": {
          height: "12px",   // change height
          minWidth: "12px", // change width
          borderRadius: "50%", // keep it circular          
        },
      }}
    >
      <IconButton
        size="small"
        onClick={(e) => {
          hasMessagesRef.current = false;
          localStorage.setItem('unreadFlag', 0);
          setHasMessages(false);
          navigate('/chat');
        }}
      >
        <ChatIcon sx={{ fontSize: 28, color: 'white' }} />
      </IconButton>
    </Badge>
  )
}

export default function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, logout } = useAppContext();

  return (
    <>
      <Stack direction={'row'} spacing={1} alignItems='center'>
        {pathname !== '/chat' &&
          <Chat />
        }

        <IconButton
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <Person sx={{ fontSize: 30, color: 'white' }} />
        </IconButton>
      </Stack>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Card
          sx={{ p: 2 }}
        >
          <Typography variant="h6">
            Olá, {user?.name?.split(' ').at(0)}!
          </Typography>

          <MenuList>
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                navigate('/login');
              }}
            >
              <ListItemIcon>
                <ContactPage />
              </ListItemIcon>
              Meus dados
            </MenuItem>

            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                logout();
              }}
              sx={{ color: 'red' }}
            >
              <ListItemIcon sx={{ color: 'red' }}>
                <Logout />
              </ListItemIcon>
              Sair
            </MenuItem>
          </MenuList>
        </Card>
      </Popover>
    </>
  )
}